import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'oligonKentimaYpsiliMiddle';
const args = {};

export class OligonKentimaYpsiliMiddle extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
